module.exports = "/assets/data/914c98891270628bd1f32f21792b1124-WC1V.data.json";